import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\DeleteTemplateDashboardController::deleteMethod
* @see app/Http/Controllers/TemplateDashboard/DeleteTemplateDashboardController.php
* @route '/api/template-dashboard/{template_dashboard}'
*/
export const deleteMethod = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/template-dashboard/{template_dashboard}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\DeleteTemplateDashboardController::deleteMethod
* @see app/Http/Controllers/TemplateDashboard/DeleteTemplateDashboardController.php
* @route '/api/template-dashboard/{template_dashboard}'
*/
deleteMethod.url = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { template_dashboard: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { template_dashboard: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            template_dashboard: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template_dashboard: typeof args.template_dashboard === 'object'
        ? args.template_dashboard.id
        : args.template_dashboard,
    }

    return deleteMethod.definition.url
            .replace('{template_dashboard}', parsedArgs.template_dashboard.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\DeleteTemplateDashboardController::deleteMethod
* @see app/Http/Controllers/TemplateDashboard/DeleteTemplateDashboardController.php
* @route '/api/template-dashboard/{template_dashboard}'
*/
deleteMethod.delete = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\TemplateDashboard\DeleteTemplateDashboardController::undoDelete
* @see app/Http/Controllers/TemplateDashboard/DeleteTemplateDashboardController.php
* @route '/api/template-dashboard/undo-delete/{id}'
*/
export const undoDelete = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undoDelete.url(args, options),
    method: 'get',
})

undoDelete.definition = {
    methods: ["get","head"],
    url: '/api/template-dashboard/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\DeleteTemplateDashboardController::undoDelete
* @see app/Http/Controllers/TemplateDashboard/DeleteTemplateDashboardController.php
* @route '/api/template-dashboard/undo-delete/{id}'
*/
undoDelete.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undoDelete.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\DeleteTemplateDashboardController::undoDelete
* @see app/Http/Controllers/TemplateDashboard/DeleteTemplateDashboardController.php
* @route '/api/template-dashboard/undo-delete/{id}'
*/
undoDelete.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undoDelete.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TemplateDashboard\DeleteTemplateDashboardController::undoDelete
* @see app/Http/Controllers/TemplateDashboard/DeleteTemplateDashboardController.php
* @route '/api/template-dashboard/undo-delete/{id}'
*/
undoDelete.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undoDelete.url(args, options),
    method: 'head',
})

const DeleteTemplateDashboardController = { deleteMethod, undoDelete, delete: deleteMethod }

export default DeleteTemplateDashboardController